import { render, staticRenderFns } from "./Inside.vue?vue&type=template&id=2b23b5dc&scoped=true&"
import script from "./Inside.vue?vue&type=script&lang=js&"
export * from "./Inside.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b23b5dc",
  null
  
)

export default component.exports